export default "__VITE_ASSET__CjsWeIiR__"